import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';
import {routerMiddleware} from 'react-router-redux';
import rootReducer from './reducers';

// Merge middlewares
const middlewares = history => [
  thunk,
  routerMiddleware(history),
];

const storeWithHistory = history => createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(
      ...middlewares(history)
    )
  )
);

export {
  storeWithHistory,
  rootReducer
};
